<div class="main-container">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card appearance="outlined">
      <mat-card-title>Template Settings</mat-card-title>
      <mat-card-content fxLayout="column">

        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
          Error occurred
        </div>

        <app-mat-simple-select fxFlex [formControl]="wabaIdControl"
                               [selectItems]="wabaIdsLookup" label="WhatsApp Business Phone Number" name="wabaId"
                               [submitted]="submitted"></app-mat-simple-select>

        <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
          <app-mat-text-input fxFlex [formControl]="nameControl" label="Name" name="name"
                              [submitted]="submitted"></app-mat-text-input>
          <app-mat-simple-select fxFlex [formControl]="categoryControl"
                                 [selectItems]="templateService.templateCategoriesRestricted" label="Category"
                                 name="category"
                                 [submitted]="submitted"></app-mat-simple-select>
          <app-mat-simple-select fxFlex [formControl]="languageControl" [selectItems]="languageLookup"
                                 label="Language" name="language" [submitted]="submitted"></app-mat-simple-select>
        </div>

        <app-mat-simple-select fxFlex [formControl]="headerFormatControl"
                               [selectItems]="templateService.templateHeaderFormats" label="Header" name="header"
                               [submitted]="submitted"></app-mat-simple-select>
        <app-mat-text-input fxFlex [formControl]="headerTextControl"
                            *ngIf="headerFormatControl.value == 'TEXT'"
                            label="Header Text"
                            name="header_text"
                            [submitted]="submitted"></app-mat-text-input>

        <app-mat-textarea-input [formControl]="bodyTextControl" label="Body" name="body"
                                [submitted]="submitted"></app-mat-textarea-input>
        <app-mat-text-input fxFlex [formControl]="footerTextControl"
                            label="Footer"
                            name="footer"
                            [submitted]="submitted"></app-mat-text-input>

        <app-mat-simple-select fxFlex
                               [formControl]="buttonsTypeControl"
                               [selectItems]="templateService.templateButtonTypes"
                               label="Buttons" name="buttonsType" [submitted]="submitted">
        </app-mat-simple-select>
        <div fxLayout="column" fxFlex="100" fxLayoutAlign="start start" formArrayName="buttons"
             *ngIf="buttonsTypeControl.value != 'NONE'">
          <div fxLayout="row" fxFill fxLayoutAlign="start start" fxLayoutGap="10px"
               *ngFor="let item of buttonsForm.controls; let i=index" [formGroupName]="i">
            <app-mat-simple-select fxFlex="20"
                                   *ngIf="buttonsTypeControl.value == 'QUICK_ACTION'"
                                   [formControl]="getFormControl('type', item)"
                                   label="Action Type"
                                   name="buttonType" [selectItems]="templateService.templateButtonActionTypes"
                                   [submitted]="submitted"></app-mat-simple-select>
            <app-mat-text-input fxFlex="30" [formControl]="getFormControl('text', item)"
                                label="Button Text"
                                name="buttonText"
                                [submitted]="submitted"></app-mat-text-input>
            <app-mat-phone-number-input fxFlex="30"
                                        *ngIf="item.value.type == 'PHONE_NUMBER' && buttonsTypeControl.value == 'QUICK_ACTION'"
                                        [formControl]="getFormControl('phone_number', item)"
                                        label="Phone Number"
                                        name="buttonPhoneNumber"
                                        [submitted]="submitted"></app-mat-phone-number-input>
            <app-mat-text-input fxFlex="30"
                                *ngIf="item.value.type == 'URL' && buttonsTypeControl.value == 'QUICK_ACTION'"
                                [formControl]="getFormControl('url', item)"
                                label="Url"
                                name="buttonUrl"
                                [submitted]="submitted"></app-mat-text-input>

            <button mat-icon-button color="warn" fxFlex="10" (click)="removeButton(i)" [disabled]="this.submitted">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          <div fxLayout="row" fxLayoutGap="5px">
            <button type="button" mat-stroked-button (click)="addButton()" [disabled]="this.submitted">
              <i class="material-icons">add</i> Add Button
            </button>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions fxLayout="row" fxLayoutGap="5px">
        <button type="submit" color="primary" mat-raised-button matTooltip="Save changes"
                [disabled]="this.submitted"
                [promiseBtn]="buttonSubmitPromise" *ngIf="hasEditAccess">Save
        </button>
        <button type="button" color="warn" mat-raised-button matTooltip="Remove template" (click)="onDeleteClick()"
                *ngIf="(hasDeleteAccess) && model.id && model.id !== 'new'">
          <i class="material-icons">delete</i>
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
